import React, { useState, useEffect, useRef } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import { useTranslation } from "react-i18next";

const BaseMetrics = ({
  metrics = {
    active: 0,
    total: 0,
    register: 0,
    confirmed: 0,
  },
}) => {
  const { t } = useTranslation();

  return (
    <div className={style.metricsSection}>
      <div className={style.metricCard}>
        <div className={style.metricTitle}>{t("partnersPage.metrics.totalInvited")}</div>
        <div className={style.metricValue}>{metrics.total}</div>
      </div>
      <div className={style.metricCard}>
        <div className={style.metricTitle}>{t("partnersPage.metrics.registrationRate")}</div>
        <div className={style.metricValue}>{metrics.register}%</div>
      </div>
      <div className={style.metricCard}>
        <div className={style.metricTitle}>{t("partnersPage.metrics.confirmed")}</div>
        <div className={style.metricValue}>{metrics.confirmed}%</div>

      </div>
      <div className={style.metricCard}>
        <div className={style.metricTitle}>{t("partnersPage.metrics.activePartners")}</div>
        <div className={style.metricValue}>{metrics.active}</div>
      </div>
    </div>
  );
};

export default BaseMetrics;
